import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { useLayoutEffect, createContext, useContext } from 'react';

/**
 * This context is made available to any components nested within
 * `FormField` and allows them to access its properties so that they
 * don't have to be repeated on both the `FormField` and the control.
 *
 * Use the `useFormFieldContext` hook to access these fields.
 */

export var FormFieldContext = /*#__PURE__*/createContext({});
/**
 * Provides access to properties defined on the parent `FormField` component
 * so that they don't have to be repeated.
 */

export function useFormFieldContext() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    id = _ref.id,
    descriptionIds = _ref.descriptionIds,
    required = _ref.required;
  var context = useContext(FormFieldContext) || {};
  var mergedDescriptionIds = descriptionIds ? "".concat(descriptionIds, " ").concat(context.descriptionIds || '') : context.descriptionIds || '';

  // Merge context values with local values,
  // and handle fallback values when the hook is
  // used without a parent FormField component

  return _objectSpread(_objectSpread({}, context), {}, {
    id: id || context.id,
    descriptionIds: mergedDescriptionIds,
    required: required || context.required
  });
}

/**
 * Notifies the parent `FormField` component that the nested
 * control is a custom component not based on `<input>` or `<select>`
 * elements, meaning that labelling it via `<label for={id}>` will not work.
 */

export function useCustomControl() {
  var _ref2 = useContext(FormFieldContext) || {},
    setIsCustomControl = _ref2.setIsCustomControl;
  useLayoutEffect(function () {
    setIsCustomControl === null || setIsCustomControl === void 0 || setIsCustomControl(true);
  }, [setIsCustomControl]);
}